import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ExportInventory from "./export-inventory";
import { PageHeader } from "components/ui/index";
import { Waiting } from "components/ui/waiting";
import HasRolePermission from "components/shared/has-role-permission";
import { selectors } from "reducers";
import InventoryTable from "./table";
import InventorySearch from "./inventory-search";
import { useDebounce } from "hooks";
import { Link } from "react-router-dom";

const InventoryTablePage = ({ isFetchingInventory, inventoryItems }) => {
  const [searchBy, setSearchBy] = useState("product_name");
  const [searchValue, setSearchValue] = useState("");
  const [productLineFilter, setProductLineFilter] = useState("cpap");
  const debouncedSearchTerm = useDebounce(searchValue, 700);
  return (
    <div className="inventory-table-container">
      <PageHeader title="Inventory Items">
        <HasRolePermission allowedRoles={["Administrator"]}>
          <ExportInventory />
        </HasRolePermission>
        <HasRolePermission allowedRoles={["Administrator"]}>
          <div className="link-button">
            <Link
              className="button small"
              to="/inventory/new"
              style={{ margin: 0 }}
            >
              Add Inventory
            </Link>
          </div>
        </HasRolePermission>
      </PageHeader>
      {!isFetchingInventory ? (
        <div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 300px",
              gap: "20px",
              marginBottom: "20px",
              alignItems: "center"
            }}
          >
            <div>
              <InventorySearch
                searchBy={searchBy}
                setSearchValue={setSearchValue}
                setSearchBy={setSearchBy}
                searchValue={searchValue}
              />
            </div>
            <div
              style={{
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}
            >
              <label
                style={{
                  fontSize: "1.1em",
                  fontWeight: "bold",
                  whiteSpace: "nowrap"
                }}
              >
                Product Line:
              </label>
              <div style={{ display: "flex", gap: "15px" }}>
                <label
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <input
                    type="radio"
                    value="cpap"
                    style={{ margin: 0 }}
                    checked={productLineFilter === "cpap"}
                    onChange={e => setProductLineFilter(e.target.value)}
                  />
                  CPAP
                </label>
                <label
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <input
                    type="radio"
                    value="cgm"
                    style={{ margin: 0 }}
                    checked={productLineFilter === "cgm"}
                    onChange={e => setProductLineFilter(e.target.value)}
                  />
                  CGM
                </label>
                <label
                  style={{
                    cursor: "pointer",
                    fontSize: "1em",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <input
                    type="radio"
                    value="all"
                    style={{ margin: 0 }}
                    checked={productLineFilter === "all"}
                    onChange={e => setProductLineFilter(e.target.value)}
                  />
                  All
                </label>
              </div>
            </div>
          </div>
          <InventoryTable
            searchBy={searchBy}
            searchValue={debouncedSearchTerm}
            inventoryItems={inventoryItems}
            productLineFilter={productLineFilter}
          />
        </div>
      ) : (
        <Waiting reason="getting inventory" />
      )}
    </div>
  );
};

export default connect(state => ({
  isFetchingInventory: selectors.isFetchingInventory(state),
  inventoryItems: selectors.getInventoryItems(state)
}))(InventoryTablePage);

InventoryTablePage.propTypes = {
  inventoryItems: PropTypes.arrayOf(PropTypes.object),
  isFetchingInventory: PropTypes.bool.isRequired
};
